import {IS_HEAD} from "../permissions/roleTypes";
import {Navigate} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";

const ProtectedRoutesOnlyAdmin = ({children}) => {
    const {roles} = useSelector(state => state.currentUser)

    const isPermitted = IS_HEAD(roles)

    if (!isPermitted) {
        return <Navigate to={'/'} replace/>
    }
    return children
}

export default ProtectedRoutesOnlyAdmin